<div
  class="dialog-alert"
  fxLayout="column"
  fxLayoutAlign="start center"
  fxLayoutGap="30px"
>
  <button
    class="dialog-alert-close"
    [mat-dialog-close]="true"
    fxFlexAlign="end"
    type="button"
    mat-icon-button
  >
    <mat-icon>close</mat-icon>
  </button>

  <span *ngIf="!dialogImageUrl" class="dialog-alert-line">
    <img class="dialog-alert-icon" [src]="iconUrl" alt="" />
  </span>

  <img class="dialog-alert-image" *ngIf="dialogImageUrl" [src]="dialogImageUrl" alt="" />

  <span *ngIf="translatable" class="dialog-alert-text">{{ text | translate }}</span>
  <span *ngIf="!translatable" class="dialog-alert-text">{{ text }}</span>

  <button routerLink="/profile" [mat-dialog-close]="true" *ngIf="showIdentityButton" mat-flat-button color="primary" class="my-button">{{"IDENTITY" | translate}}</button>

  <div *ngIf="excessiveAmount" class="" fxLayout="row" fxLayoutGap="50px">

    <button routerLink="/shop" [mat-dialog-close]="false"  mat-flat-button color="primary">{{"GO_TO_SHOP" | translate}}</button>
    <button  [mat-dialog-close]="true"  mat-flat-button color="primary">{{"CONTINUE" | translate}}</button>
  </div>
</div>
